import { Navigate, Route, Routes } from "react-router-dom";

import { BlacklistedPractice } from "./BlacklistedPractice";
import { BookmarkedPractice } from "./BookmarkedPractice";
import { EnvelopePractice, EnvelopeSuperTopicPractice } from "./EnvelopePractice";
import { PracticeEvaluation } from "./Evaluation";
import { SuperTopicPractice } from "./SuperTopicPractice";

const PracticeRoutes = () => (
  <Routes>
    <Route path="/">
      <Route path="/tema/:themeId" element={<SuperTopicPractice />} />
      <Route path="/ulozene" element={<BookmarkedPractice />} />
      <Route path="/vyrazene" element={<BlacklistedPractice />} />
      <Route path="/obalka/:envelopeId" element={<EnvelopePractice />} />
      <Route path="/obalka/:envelopeId/tema/:themeId" element={<EnvelopeSuperTopicPractice />} />
      <Route path="/vyhodnoceni" element={<PracticeEvaluation />} />

      <Route path="*" element={<Navigate to="/" />} />
    </Route>
  </Routes>
);

export default PracticeRoutes;
